import { PolIcon } from "components/PolIcon/policon";
import React from 'react';
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import { usePolTranslation } from "v4/hooks/usePolTranslation";

export default function ProspectsListingActions() {
    const { t } = usePolTranslation();
    const { getRouteByNativeIdentifier } = useNavigation();

    return (
        <>
            <li className="action">
                <Link to={`${getRouteByNativeIdentifier('main_prospects').url}/add/business`} data-for="add" data-tip={t('add_company')}>
                    <PolIcon icon="add-company" className="action__picto"/>
                </Link>
            </li>
            <li className="action">
                <Link to={`${getRouteByNativeIdentifier('main_prospects').url}/add/individual`} data-for="add" data-tip={t('add_prospect')}>
                    <PolIcon icon="add-client" className="action__picto"/>
                </Link>
            </li>
            <ReactTooltip id="add" effect="solid"/>
        </>
    )
}
